import axios from 'axios'
// import Qs from 'qs'
import router from '@/router/index'
import { useUserStore } from '@/stores/user'

const toLogin = () => {
    router.push({
        path: '/login',
        query: {
            redirect: router.currentRoute.fullPath
        }
    })
}

const api = axios.create({
    baseURL: "http://localhost:8232",
    timeout: 10000,
    responseType: 'json'
})

api.interceptors.request.use(
    request => {
        const userStore = useUserStore();
        if (request.method === 'post') {
            if (request.data instanceof FormData) {
                if (userStore.isLoggedIn) {
                    if (request.params == undefined) {
                        request.params = {};
                    }
                    request.params.token = userStore.token;
                }
            } else {
                if (request.data == undefined) {
                    request.data = {};
                }
                if (userStore.isLoggedIn) {
                    if (request.params == undefined) {
                        request.params = {};
                    }
                    request.params.token = userStore.token;
                }
            }
        } else {
            if (request.params == undefined) {
                request.params = {};
            }
            if (userStore.isLoggedIn) {
                request.params.token = userStore.token;
            }
        }
        return request;
    }
);

api.interceptors.response.use(
    response => {
        if (response.status === 200) {
            return Promise.resolve(response.data);
        } else {
            toLogin();
        }
    },
    error => {
        return Promise.reject(error);
    }
);

export default api;